var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.55 4.35A2.75 2.75 0 0 1 6.3 1.6h11.4a2.75 2.75 0 0 1 2.75 2.75v16.477a1.25 1.25 0 0 1-1.826 1.11l-6.509-3.382a.25.25 0 0 0-.23 0l-6.509 3.381a1.25 1.25 0 0 1-1.826-1.109V4.35ZM6.3 3.1c-.69 0-1.25.56-1.25 1.25v16.066l6.143-3.192a1.75 1.75 0 0 1 1.614 0l6.143 3.192V4.35c0-.69-.56-1.25-1.25-1.25H6.3Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 5.33a.75.75 0 0 1 .678.429l1.187 2.505 2.748.355a.75.75 0 0 1 .42 1.289l-2.016 1.903.512 2.723a.75.75 0 0 1-1.097.797L12 14.003 9.567 15.33a.75.75 0 0 1-1.096-.796l.512-2.724-2.015-1.903a.75.75 0 0 1 .418-1.29l2.75-.354 1.186-2.505A.75.75 0 0 1 12 5.33Zm0 2.501-.685 1.445a.75.75 0 0 1-.582.423l-1.585.205L10.31 11a.75.75 0 0 1 .223.684l-.296 1.571 1.403-.766a.75.75 0 0 1 .72 0l1.403.766-.296-1.571a.75.75 0 0 1 .223-.684l1.162-1.097-1.586-.205a.75.75 0 0 1-.581-.423L12 7.831Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/运营管理.01bef1b83e4810f748b2747c4aa362b3.svg";
export { ForwardRef as ReactComponent };